import React, { useState } from "react";
import { Drawer, Form } from "antd";

export default ({ detail }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <a onClick={() => setOpen(true)}>查看详情</a>
      <Drawer
        title="详情"
        width={500}
        destroyOnHidden
        open={open}
        onClose={() => setOpen(false)}
      >
        <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
          <Form.Item label="ID">{detail.id}</Form.Item>
          <Form.Item label="圈子名称">{detail.name}</Form.Item>
          <Form.Item label="类型">{detail.type}</Form.Item>
          <Form.Item label="圈主">{detail.circleOwner}</Form.Item>
          <Form.Item label="加精">{detail.featuredFlag}</Form.Item>
          <Form.Item label="圈子用户数">{detail.userCount}</Form.Item>
          <Form.Item label="圈子内容数">{detail.contentCount}</Form.Item>
          <Form.Item label="圈子成立时间">{detail.establishmentDate}</Form.Item>
          <Form.Item label="发布状态">{detail.status}</Form.Item>
        </Form>
      </Drawer>
    </>
  );
};
